import { Stack } from '@chakra-ui/react';
import React from 'react';
import IntakeConfig from '../../../interfaces/IntakeConfig.interface';
import BusinessAddressView from '../BusinessAddressView';
import BusinessContactView from '../BusinessContactView';
import BusinessNameView from '../BusinessNameView';
import BusinessPresenceView from '../BusinessPresenceView';
import MainButton from '../form/MainButton';

const BusinessMainSection = ({ config }: {
  config: IntakeConfig,
}) => {
  return (
    <Stack direction="column" spacing={16} width={{ base: '100%', lg: '66%' }}>
      <div>{/* Preserve top margin on BusinessNameView  */}</div>
      <BusinessNameView />
      <BusinessAddressView config={config} />
      <BusinessContactView />
      <BusinessPresenceView />
      <MainButton type="submit">Select Plan Options</MainButton>
    </Stack>
  );
};

export default BusinessMainSection;
